import { Typography, TextField, Grid } from "@mui/material";
import Button from "../common/Button";
import React, { useEffect, useState } from "react";
import "./Student.scss";
import { Stack } from "@mui/system";
import { Box, Switch } from "@mui/material";
import SearchBar from "../common/searchBar";
import DateRangePicker from "../TP_DateRangePicker";
import Dropdown from "../TP_Dropdown";
import StudentList from "./StudentList";
import StudentCard from "./StudentCard";
import StudentDetails from "./StudentDetails";
import { useDispatch, useSelector } from "react-redux";
// import SearchIcon from '@material-ui/icons/Search';
import axios from "../../globals/common_utilities/axios_old";
import CONSTANTURL from "../../globals/common_utilities/constanturls";
import { API, APP_ROUTES } from "../../globals/constants";
import ToggleButton from "../ToggleButton";
import Loading from "../loader";
import {
  setcheckedList,
  setemptyDeleteList,
  setemptycheckedList,
} from "../../redux/features/student";
import CsvDownloader from "react-csv-downloader";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import SubHeading from "../common/SubHeading";
import Pagination from "@mui/material/Pagination";
import Cookies from "universal-cookie";
import MultiLine_Spinner from "../multiline_spinner/Multiline_spinner";
import DeleteAlert from "../DeleteAlert/DeleteModal";
import SingleDelete from "../SingleDeleteAlert/SingleDelete";
import moment from "moment";

const Student = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [checked, setChecked] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [apiResponse, setApiResponse] = useState([]);
  const [loading, setloading] = useState(true);
  const [flag, setFlag] = useState(true);
  const [loadApi, setloadApi] = useState(false);
  const limit = 12;
  const [showModal, setShowModal] = useState(false);
  const [showSingleModal, setShowSingleModal] = useState(false);
  const [singleDeleteId, setSingleDeleteId] = useState();
  const [exportapiResponse, setexportApiResponse] = useState([]);
  let currentDate = new Date();

  let previousDate = new Date();
  let lastday = previousDate.setDate(previousDate.getDate() - 7);
  const [queryParamas, setqueryParamas] = useState({
    limit: limit || 12,
    offset: 0,
    is_active: true,
  });
  const [pageCount, setPageCount] = useState();
  const [selectLocation, setSelectLocation] = useState([]);
  const [allTC, setAllTC] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const getAllTC = async () => {
    const response = await axios(
      "GET",
      CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO +
        API.END_POINTS.STUDIO_LIST +
        `?` +
        `is_active=true`,
      {},
      {},
      {}
    )
      .then((response) => {
        const list = response?.data?.data?.rows?.map((value) => ({
          id: value?.id,
          value: value?.studio_name,
          label: value?.studio_name,
        }));
        setAllTC(list);
      })
      .catch((err) => {
        toast.error("LOCATION NOT FOUND", {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });
      });
  };

  const onPageClickhandler = (e, data) => {
    if (searchTerm !== "" && searchTerm !== undefined) {
      setqueryParamas((prevState) => ({
        ...prevState,
        offset: Math.ceil((data - 1) * limit),
        name: searchTerm,
      }));
    } else {
      setqueryParamas((prevState) => ({
        ...prevState,
        offset: Math.ceil((data - 1) * limit),
      }));
    }
  };

  const switchHandler = (event) => {
    setChecked(event.target.checked);
  };

  let studentDetails = useSelector((state) => state.studentDetail?.showdetails);
  let multipleDelete = useSelector((state) => state.studentDetail?.deleteList);

  let multipleChecked = useSelector(
    (state) => state.studentDetail?.checkedList
  );

  let studioName = apiResponse?.map((value) => ({
    id: value?.[`location.id`],
    value: value.name,
    label: value.name,
  }));

  let uniqueName = [
    ...new Map(studioName?.map((item) => [item["value"], item])).values(),
  ];

  let instructor = apiResponse?.map((value) => ({
    id: value?.[`studio.id`],
    value: value?.[`studio.studio_name`],
    label: value?.[`studio.studio_name`],
  }));

  let uniqueInstructor = [
    ...new Map(instructor?.map((item) => [item["value"], item])).values(),
  ];

  const dropdownSelect = async (getName) => {
    let params = {};
    Object.assign(params, queryParamas);
    if (params.offset) {
      params.offset = 0;
    }
    getName?.id
      ? (params.studio_id = `${getName?.id}`)
      : delete params.studio_id;
    setqueryParamas({ ...params });
  };

  const cookies = new Cookies();
  const loginData = cookies.get("loginData");
  let userID = loginData?.id;
  let userRole = loginData?.role_code;
  let userStudioID = loginData?.studio_id;

  const apiCall = async (name) => {
    // const name_Key = "name" in queryParamas;
    // if (name_Key) {
    //   delete queryParamas.offset;
    // }
    // queryParamas.limit = 12;
    let params = {};
    if (name) {
      // setqueryParamas({
      //   ...queryParamas,
      //   name: name,
      // });
      params = {
        ...queryParamas,
        name,
      };
    } else {
      params = queryParamas;
    }
    setloading(true);
    if (userRole === "STUDIO_ADMIN") {
      const response = await axios(
        "GET",
        CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDENT +
          API.END_POINTS.STUDENT_ENDPOINT +
          `?` +
          `studio_id=${userStudioID}`,
        params,
        {},
        {}
      ).then((response) => {
        setApiResponse(response?.data?.data?.rows);
        setPageCount(() => Math.ceil(response?.data?.data?.count / limit));
        setloading(false);
        return response.data;
      });
    } else {
      setloading(true);
      const response = await axios(
        "GET",
        CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDENT +
          API.END_POINTS.STUDENT_ENDPOINT,
        params,
        {},
        {}
      ).then((response) => {
        setApiResponse(response?.data?.data?.rows);
        setPageCount(() => Math.ceil(response?.data?.data?.count / limit));
        setloading(false);
        return response.data;
      });
    }
  };

  const exportapiCall = async () => {
    let qp = {};
    Object.assign(qp, queryParamas);
    const from_date_Key = "from_date" in qp;
    const end_date_Key = "end_date" in qp;
    const name_Key = "name" in qp;
    const studio_id_Key = "studio_id" in qp;
    const location_id_Key = "location_id" in qp;

    if (
      from_date_Key ||
      end_date_Key ||
      name_Key ||
      studio_id_Key ||
      location_id_Key
    ) {
      delete qp.limit;
      delete qp.offset;
    }
    setloading(true);
    if (userRole === "STUDIO_ADMIN") {
      const response = await axios(
        "GET",
        CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDENT +
          API.END_POINTS.STUDENT_ENDPOINT +
          `?` +
          `studio_id=${userStudioID}`,
        qp,
        {},
        {}
      ).then((response) => {
        setexportApiResponse(response?.data?.data?.rows);
        setPageCount(() => Math.ceil(response?.data?.data?.count / limit));
        setloading(false);
        return response.data;
      });
    } else {
      setloading(true);
      const response = await axios(
        "GET",
        CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDENT +
          API.END_POINTS.STUDENT_ENDPOINT,
        qp,
        {},
        {}
      ).then((response) => {
        setexportApiResponse(response?.data?.data?.rows);
        setPageCount(() => Math.ceil(response?.data?.data?.count / limit));
        setloading(false);
        return response.data;
      });
    }
  };

  const singleDelete = (list) => {
    setSingleDeleteId(list);
    setShowSingleModal(true);
  };

  const multipleDeleteList = (list) => {
    if (multipleDelete.length < 1) {
      toast.error("Select Records To Delete", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
    } else {
      setShowModal(true);
    }
  };

  const searchStudio = async (value) => {
    // let params = queryParamas;

    // StudioName ? (params.name = `${StudioName}`) : delete params.name;
    // setqueryParamas(
    //   StudioName ? { ...queryParamas, name: StudioName } : { ...queryParamas }
    // );
    setSearchTerm(value);
  };

  const exportFile = () => {
    // exportapiCall();
    dispatch(setemptyDeleteList());
    dispatch(setemptycheckedList());
  };

  const datefilter = async (range) => {
    let startDate = range[0];
    let endDate = range[1];
    let params = {};
    Object.assign(params, queryParamas);
    if (params.offset) {
      params.offset = 0;
    }
    range[0]
      ? (params.from_date = `${moment(startDate).format("YYYY-MM-DD")}`)
      : delete params.from_date;

    range[1]
      ? (params.end_date = `${moment(endDate).format("YYYY-MM-DD")}`)
      : delete params.end_date;
    setqueryParamas({ ...params });
  };

  let location = apiResponse?.map((value) => ({
    id: value?.[`location.id`],
    value: value?.[`location.address`],
    label: value?.[`location.address`],
  }));

  let uniqueLocation = [
    ...new Map(location?.map((item) => [item["value"], item])).values(),
  ];

  const dropdownSelectLocation = async (getName) => {
    let params = {};
    Object.assign(params, queryParamas);
    if (params.offset) {
      params.offset = 0;
    }
    getName?.id
      ? (params.location_id = `${getName?.id}`)
      : delete params.location_id;
    setqueryParamas({ ...params });
    // if (getName.id) {
    // 	const response = await axios(
    // 		'GET',
    // 		CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDENT +
    // 			API.END_POINTS.STUDENT_ENDPOINT +
    // 			`?` +
    // 			`location_id=${getName.id}`,
    // 		{},
    // 		{},
    // 		{}
    // 	).then((response) => {
    // 		setApiResponse(response?.data?.data?.rows);
    // 		setloading(false);
    // 		return response.data;
    // 	});
    // }
  };

  const columns = [
    { displayName: "Student Name", id: "name" },
    { displayName: "Date", id: "created_at" },
    {
      displayName: "Training Center Name",
      id: "studio.studio_name",
    },
    {
      displayName: "Average Session Length",
      id: "avg_session_length",
    },
    {
      displayName: "No. of disconnect",
      id: "training_disconnect",
    },
    {
      displayName: "No. of session attended",
      id: "training_count",
    },
  ];

  const datas =
    multipleChecked.length > 0 ? multipleChecked : exportapiResponse;

  useEffect(() => {
    if (loadApi) {
      apiCall();
      exportapiCall();
    } else {
      setloadApi(true);
    }
  }, [queryParamas]);

  useEffect(() => {
    const callAPI = async () => {
      await apiCall(searchTerm);
    };
    callAPI();
  }, [searchTerm]);

  useEffect(() => {
    if (window.innerWidth < 770) {
      setChecked(true);
    } else {
      setChecked(false);
    }
  }, [window.innerWidth]);

  const clearButton = () => {
    document.getElementById("StudentCLearDate").click();

    if (userRole == "SUPER_ADMIN") {
      document.getElementById("StudentDropCLearFilter").click();
    }

    document.getElementById("locationCLearFilter").click();
    setShowFilter(!showFilter);
  };

  const getLocation = async () => {
    const response = await axios(
      "GET",
      CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO +
        API.END_POINTS.GET_LOCATION +
        `?` +
        `is_active=true`,
      {},
      {},
      {}
    )
      .then((response) => {
        const location = response?.data?.data?.rows?.map((value) => ({
          id: value?.id,
          value: value?.address,
          label: value?.address,
        }));
        setSelectLocation(location);
      })
      .catch((err) => {
        toast.error("LOCATION NOT FOUND", {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });
      });
  };

  const closemodal = () => {
    setShowModal(false);
    setShowSingleModal(false);
  };

  const deleteList = async () => {
    const response = await axios(
      "DELETE",
      CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDENT +
        API.END_POINTS.STUDENT_USER_DELETE +
        `?` +
        `ids=[${multipleDelete.map((value) => `"${value}"`)}]`,
      {},
      {},
      {}
    )
      .then((response) => {
        toast.success("Record Deleted", {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });
        apiCall();
        setFlag(!flag);
        setShowModal(false);
        dispatch(setemptyDeleteList());
        dispatch(setemptycheckedList());
        return response.data;
      })
      .catch(() => {
        setShowModal(false);
        toast.error("RECORDS NOT DELETED", {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });
      });
  };

  const singleDeleteModal = async () => {
    const response = await axios(
      "DELETE",
      CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDENT +
        API.END_POINTS.STUDENT_USER_DELETE +
        `?` +
        `ids=["${singleDeleteId}"]`,
      {},
      {},
      {}
    )
      .then((response) => {
        toast.success("Record Deleted", {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });
        apiCall();
        setFlag(!flag);
        setShowSingleModal(false);
        return response.data;
      })
      .catch(() => {
        setShowSingleModal(false);
        toast.success("RECORDS NOT DELETED", {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });
      });
  };

  useEffect(() => {
    getLocation();
  }, []);

  useEffect(() => {
    if (userRole === "SUPER_ADMIN") {
      getAllTC();
    }
  }, []);

  return (
    <>
      {showModal ? (
        <DeleteAlert closeModal={closemodal} deleteList={deleteList} />
      ) : (
        ""
      )}
      {showSingleModal ? (
        <SingleDelete
          closeModal={closemodal}
          singleDeleteModal={singleDeleteModal}
        />
      ) : (
        ""
      )}
      <div className="scrollContainer">
        <Stack direction="row" spacing={"20%"}>
          {studentDetails ? (
            ""
          ) : (
            <SubHeading
              title={"Student"}
              checked={checked}
              switchHandler={switchHandler}
              gridview={switchHandler}
              searchChange={searchStudio}
              multipleDeleteList={multipleDeleteList}
              columns={columns}
              datas={() => {
                return datas;
              }}
              exportFile={exportFile}
              redirect={APP_ROUTES.ADD_STUDENT}
              setShowFilter={setShowFilter}
              showFilter={showFilter}
              exportfileTitle={"Student_master_data"}
              // addText={"Add Student"}
            />
          )}
        </Stack>

        <div style={{ display: showFilter ? "contents" : "none" }}>
          <Stack
            direction="row"
            className="datepickercontainer_filter"
            justifyContent={"space-around"}
            marginTop="1%"
          >
            <Grid container>
              <Grid item flexGrow={0.2} xs={12} sm={12} md={5} lg={4}>
                <DateRangePicker
                  className="setCursor"
                  getdateRange={datefilter}
                  clearID={"StudentCLearDate"}
                  // startDateProps={lastday}
                  // endDateProps={currentDate}
                />
              </Grid>
              <Grid
                container
                direction={"row"}
                flexGrow={0.2}
                xs={12}
                sm={12}
                md={7}
                lg={8}
              >
                {userRole == "SUPER_ADMIN" ? (
                  <Grid item flexGrow={0.2} xs={6} sm={6} md={4} lg={4}>
                    <Dropdown
                      className="setCursor"
                      placeholder="Training Center"
                      options={allTC}
                      selectDropDown={dropdownSelect}
                      clearID={"StudentDropCLearFilter"}
                    />
                  </Grid>
                ) : (
                  ""
                )}
                <Grid
                  item
                  flexGrow={0.3}
                  xs={6}
                  sm={6}
                  md={4}
                  lg={4}
                  // marginTop={{ xs: '1%', sm: '1%', md: '2%' }}
                >
                  <Dropdown
                    className="setCursor"
                    placeholder="Location"
                    options={selectLocation}
                    selectDropDown={dropdownSelectLocation}
                    clearID={"locationCLearFilter"}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={4}
                  lg={4}
                  className="marginTopInstrut"
                >
                  <Button
                    className="fs-4"
                    value="Clear Filter"
                    role="clearFilter"
                    onClick={() => {
                      clearButton();
                    }}
                  >
                    Clear Filter
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Stack>
        </div>

        <>
          {studentDetails ? (
            <StudentDetails res={apiResponse} ondeleteClick={singleDelete} />
          ) : (
            <Box
              sx={{ bgcolor: "#232135", height: "100vh" }}
              className="stud_mainBox"
            >
              {checked ? (
                <>
                  {loading ? (
                    <MultiLine_Spinner />
                  ) : (
                    <Stack direction="row" width="100%" flexWrap="wrap">
                      <StudentCard
                        res={apiResponse}
                        lgWidth={"4"}
                        ondeleteClick={singleDelete}
                      />
                    </Stack>
                  )}
                </>
              ) : (
                <>
                  {loading ? (
                    <MultiLine_Spinner />
                  ) : (
                    <Stack>
                      {apiResponse?.length > 0 ? (
                        apiResponse?.map((res) => {
                          return (
                            <Stack
                              onClick={() => {
                                // setShowDetails(true);
                              }}
                            >
                              <StudentList
                                res={res}
                                ondeleteClick={singleDelete}
                              />
                            </Stack>
                          );
                        })
                      ) : (
                        <Stack className="NO_RECORD_FOUND">
                          No Record Found
                        </Stack>
                      )}
                    </Stack>
                  )}
                </>
              )}
            </Box>
          )}
          {/* {studentDetails == false ? (
					<Stack alignItems="end" marginTop={'0.5%'}>
						<Pagination count={pageCount} onChange={onPageClickhandler} />
					</Stack>
				) : (
					''
				)} */}
        </>
      </div>
      {studentDetails == false ? (
        <Stack alignItems="end" marginTop={"0.5%"}>
          <Pagination
            count={pageCount}
            onChange={onPageClickhandler}
            disabled={pageCount === 1}
          />
        </Stack>
      ) : (
        ""
      )}
    </>
  );
};

export default Student;
